import { render, staticRenderFns } from "./edit-icon-btn.vue?vue&type=template&id=2354f519&scoped=true&"
var script = {}
import style0 from "./edit-icon-btn.vue?vue&type=style&index=0&id=2354f519&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354f519",
  null
  
)

export default component.exports